/**
 * API layer liên hệ — gửi yêu cầu tư vấn (public) và quản lý (admin).
 */
import { apiClient } from '../../../shared/services/apiClient';
import { API_ROUTES } from '../../../shared/constants/apiRoutes';

/** Các hàm gọi API liên hệ. */
export const contactApi = {
  /** Gửi form liên hệ từ trang chi tiết BĐS. */
  submitContact: (payload) => apiClient.post(API_ROUTES.contacts, payload),
  /** Lịch sử liên hệ của user đăng nhập. */
  getMyContacts: (page = 1) =>
    apiClient.get(API_ROUTES.myContacts, { params: { page } }),
  /** Danh sách liên hệ admin (có filter). */
  getContacts: (params = {}) => apiClient.get(API_ROUTES.adminContacts, { params }),
  /** Cập nhật trạng thái/ghi chú liên hệ. */
  updateContact: (contactId, payload) =>
    apiClient.put(API_ROUTES.contactDetails(contactId), payload),
};
